import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['vehicleSection', 'serviceSection', 'branch', 'branchSection'];

  toggleFields(event) {
    console.log(event.target.height);
    if (event.target.value == 'warranty') {
      this.vehicleSectionTarget.classList.remove('is-hidden');
      this.serviceSectionTarget.classList.remove('is-hidden');
      this.branchSectionTarget.classList.add('is-hidden');
      this.branchTarget.disabled = true;
    } else {
      this.vehicleSectionTarget.classList.add('is-hidden');
      this.serviceSectionTarget.classList.add('is-hidden');
      this.branchSectionTarget.classList.remove('is-hidden');
      this.branchTarget.disabled = false;
    }
  }
}
